"use strict";

angular.module("internal.education").directive("internalEducationConfigNavigation", [
    function () {
        return {
            restrict: "E",
            templateUrl:
                paths.app +
                "education/components/education-config-navigation/education-config-navigation.html",
            replace: true,
            controller: ('InternalNavigation', ['$rootScope', '$scope', 'Permissions', function ($rootScope, $scope, Permissions) {
                $scope.internalURL = $rootScope.internalURL;
                $scope.getPermission = function (state, variable, method) {
                    Permissions[method](state).then(function (access) {
                        $scope[variable] = access;
                    })
                }
            }])
        };
    }
]);
